/* eslint-disable no-use-before-define */
import React from 'react'
import { useOrderTicket } from '../../use-order-ticket'
import { fmt, arrayFrom, isEmpty, showModal, Flyout } from '../../../twd'


const recentTradesTooltip = `
    This table serves as a quick reference point to observe price and yield information related to
    recently reported FINRA TRACE or MSRB trades. For expanded historical trace data, please click the “Expand trade history” link
    located above the table. Trade details may be unavailable for inactively traded CUSIPs, or non-reportable securities.
`

export const RecentTrades = () => {
    const { cusip, bondInfo, } = useOrderTicket()
    const recentTrades = bondInfo.recentTrades

    const holdInvType = bondInfo.issue && bondInfo.issue.type
    const hasTradeHistory = ['A','C','M'].indexOf(holdInvType)>=0

    if (!hasTradeHistory) return null

    const hasRecentTrades = !isEmpty(recentTrades)

    return <React.Fragment>
    <div className="row">
        <div className="col-xs-6">
            <Flyout
                label="Recent trade activity"
                className="btn-label btn-flyout h3"
                html={recentTradesTooltip}
            />
        </div>
        <div className="col-xs-6 text-right">
        <button
            type="button"
            className="btn-link"
            onClick={(e) => {
                let p = {
                    view: 'trade-history',
                    cusip,
                    source: e.target,
                }
                showModal(p)
            }}
            >Expand trade history</button>
        </div>
    </div>

    { !hasRecentTrades && <React.Fragment>
        <div className="row text-center vertical-offset-xs">
        <div className="vertical-offset-xs">
        <i className="et-icon et-alert et-icon-md" aria-hidden="true"></i>
        </div>
        <div className="vertical-offset-xs">
        <div className="small-header vertical-offset-xxs">No trade activity in the last 30 days</div>
        </div>
        </div>

        <div className="row vertical-offset-xs"><div className="col-md-12"><hr aria-hidden={true} /></div></div>
        </React.Fragment>}

    { hasRecentTrades &&
        <div className="table-responsive">
        <table className="table table-striped"
            style={{display:"block", maxHeight:"250px", overflowY:"auto"}}
            >
        <thead>
            <tr>
            <th className="col-md-3">Trade Date</th>
            <th className="col-md-2 text-right">Quantity</th>
            <th className="col-md-1 text-right">Price</th>
            <th className="col-md-1 text-right">Yield</th>
            <th className="col-md-3">Type</th>
            </tr>
        </thead>
        <tbody>
            { arrayFrom(recentTrades)
                .map(({trade_date_time, timeofTrade, quantity, price, yield:yield_, tradeType, estimate_flag},i) => {
                    return <tr key={i}>
                        <td className="text-nowrap">{fmt.ts(trade_date_time + ' ' + timeofTrade)}</td>
                        <td className="text-right">{estimate_flag  ? '* 1,000' : fmt.qty(quantity)}</td>
                        <td className="text-right">{fmt.price3(price)}</td>
                        <td className="text-right">{fmt.price3(yield_)}</td>
                        <td className='text-nowrap'>{TradeTypeMap[tradeType] || tradeType}</td>
                    </tr>
                })
            }
        </tbody>
        </table>
        </div>}

    </React.Fragment>
}


const TradeTypeMap = {
    'Customer Bought': 'Customer Buy',
    'Customer Sold': 'Customer Sell',
    'Inter-dealer Trade': 'Dealer to Dealer',
}